export default __webpack_public_path__ + "static/media/Group 1.5b6aee07.svg";